// import external dependencies
import jquery from 'jquery';

declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = window.jQuery = jquery;

import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';

import './modules/sliders';
import './modules/age-check';
import './modules/hero-home-animation';
import './modules/partners';
import './modules/aos';
import './modules/title';